import Vue from 'vue'
import objectToFormData from "object-to-formdata";

const initialState = {
  list: [],
  categories: [],
  issue: {},
  detail: {},
  loading: false
}

export default {
  namespaced: true,
  state: {
    ...initialState
  },
  mutations: {
    SET(state, data) {
      state[data.key] = data.val
    },
    CLEAR(state, key = false) {
      if (key)
        state[key] = initialState[key]
      else state = {...initialState}
    },
    ADD_COMMENT(state, comment) {
      state.detail = {
        ...state.detail,
        comments: [comment, ...state.detail.comments]
      }
    },
    EDIT_COMMENT(state, editedComment) {
      state.detail = {
        ...state.detail,
        comments: state.detail.comments.map(comment => {
          if (comment.id === editedComment.id) {
            return editedComment
          } else return comment
        })
      }
    },
    REMOVE_COMMENT(state, id) {
      state.detail = {
        ...state.detail,
        comments: state.detail.comments.filter((comment) => comment.id !== id)
      }
    }
  },
  actions: {
    getDetail({commit}, issueId) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`issue_tracker/issues/${issueId}/`).then(response => {
          commit('SET', {key: 'detail', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getIssue({commit}, issueId) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`issue_tracker/issues/${issueId}/`).then(response => {
          commit('SET', {key: 'issue', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    create({commit}, issue) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.post(`issue_tracker/issues/`, objectToFormData(issue)).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    nextState({commit, state}, note) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.post(`issue_tracker/issues/${state.detail.id}/next_state/`, {note}).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    update({commit}, issue) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.put(`issue_tracker/issues/${issue.id}/`, objectToFormData(issue)).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    cancel({commit, state}, note) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.post(`issue_tracker/issues/${state.detail.id}/cancel/`, {note}).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getRelations({commit}, issueId = null) {
      let path = `issue_tracker/issues/relations/`
      if (issueId) {
        path = `issue_tracker/issues/relations/?issue_id=${issueId}`
      }
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.get(path).then((response) => {
          commit('SET', {key: 'categories', val: response.data.categories})
          commit('SET', {key: 'issue', val: response.data.issue})
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    createComment({commit, state}, text) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.post(`issue_tracker/issues/${state.detail.id}/comments/`, {text}).then(response => {
          commit('ADD_COMMENT', response.data)
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    updateComment({commit, state}, {text, id}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.patch(`issue_tracker/issues/${state.detail.id}/comments/${id}/`, {text}).then(response => {
          commit('EDIT_COMMENT', response.data)
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    removeComment({commit, state}, id) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.delete(`issue_tracker/issues/${state.detail.id}/comments/${id}/`).then(() => {
          commit('REMOVE_COMMENT', id)
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    }
  }
}
